module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-57x57-2d8ee2e72ed3dd7c3d34c6d6c3a32bf5.png";